<app-tables
  [tableHeader]="tableHeader"
  [footerText]="footerText"
  [columns]="columns"
  [url]="url"
  [filters]="filters"
  (onActionButtonClick)="actionButtonClick($event.actionType, $event.row)"
  [columnWidths]="columnWidths"
  [type]="'consultationList'"
  [signalModel]="signalrModel"
></app-tables>